import { api, type Paginated } from "./client";

// Mirrors app/routers/changelog.py ChangelogEntryOut.
export interface ChangelogEntry {
  changelog_id: number;
  entry_date: string; // YYYY-MM-DD
  category: "feature" | "fix" | "improvement" | "maintenance" | "notice";
  title: string;
  description: string;
}

export interface ChangelogListParams {
  page?: number;
  per_page?: number;
}

export async function listChangelog(params: ChangelogListParams = {}): Promise<Paginated<ChangelogEntry>> {
  const resp = await api.get<Paginated<ChangelogEntry>>("/changelog/", { params });
  if (!resp.data.success) throw new Error(resp.data.error || "Failed to load changelog");
  return resp.data;
}
